export default "/images/vendor/flag-icons/flags/1x1/fm.svg?9b826793a052bef7921929fcf9a87607";